module.exports = __webpack_public_path__ + "assets/successSparkleB-189fba.svg";